import React from "react";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Box, Link, Stack, Typography } from "@mui/material";
import NetworkPersonTile from "./NetworkPersonTile";

function InviteTile({ onClick }) {
  return (
    <Box
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(event) => {
        if (event.key === "Enter" || event.key === " ") {
          event.preventDefault();
          onClick?.();
        }
      }}
      sx={{
        minWidth: 96,
        textAlign: "center",
        cursor: "pointer",
        borderRadius: 3,
        px: 0.6,
        py: 0.8,
        transition: "background-color 160ms ease, box-shadow 160ms ease, transform 160ms ease",
        "&:hover": {
          backgroundColor: "rgba(237, 243, 249, 0.72)",
          transform: "translateY(-1px)",
        },
        "&:focus-visible": {
          outline: "none",
          backgroundColor: "rgba(237, 243, 249, 0.82)",
          boxShadow: "0 0 0 2px rgba(23, 52, 93, 0.14)",
        },
      }}
    >
      <Box
        sx={{
          width: 78,
          height: 78,
          mx: "auto",
          borderRadius: "50%",
          display: "grid",
          placeItems: "center",
          border: "2px dashed rgba(23, 52, 93, 0.2)",
          color: "#17345d",
          bgcolor: "rgba(237, 243, 249, 0.95)",
        }}
      >
        <AddRoundedIcon sx={{ fontSize: 32 }} />
      </Box>
      <Typography variant="subtitle2" fontWeight={800} sx={{ mt: 1.1, color: "#17345d" }}>
        Invite
      </Typography>
      <Typography variant="caption" sx={{ color: "#254b79", fontWeight: 600 }}>
        friends
      </Typography>
    </Box>
  );
}

export default function NetworkPeopleStrip({
  people,
  onPersonClick,
  onInviteClick,
  onViewAll,
  viewAllLabel = "View all",
}) {
  return (
    <Box
      sx={{
        px: 2.2,
        py: 1.8,
        borderRadius: 3,
        border: "1px solid rgba(231, 235, 244, 1)",
        bgcolor: "#fff",
        boxShadow: "0 8px 22px rgba(30, 41, 59, 0.04)",
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1.6 }}>
        <Typography variant="subtitle1" fontWeight={800} sx={{ color: "#1d2746" }}>
          Around you
        </Typography>
        {onViewAll ? (
          <Link
            component="button"
            underline="none"
            onClick={onViewAll}
            sx={{
              display: "inline-flex",
              alignItems: "center",
              gap: 0.25,
              color: "#17345d",
              fontWeight: 700,
              fontSize: 14,
            }}
          >
            {viewAllLabel}
            <ChevronRightRoundedIcon sx={{ fontSize: 18 }} />
          </Link>
        ) : null}
      </Stack>

      <Box sx={{ display: "flex", gap: 2, overflowX: "auto", pb: 0.1 }}>
        {people.map((person) => (
          <NetworkPersonTile key={person.id} person={person} onClick={onPersonClick} />
        ))}
        <InviteTile onClick={onInviteClick} />
      </Box>
    </Box>
  );
}
